import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './ProjectsSection.css';

const cities = ['Chennai', 'Coimbatore', 'Kodaikanal', 'Adambakkam', 'Kancheepuram'];
const projectTypes = ['Residential', 'Commercial', 'Institutional'];
const allProjects = [
  {
    id: 1,
    type: 'Residential',
    city: 'Chennai',
    name: 'Thiruvikrama',
    address: 'Besant Nagar',
    image: 'https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=800&h=600&fit=crop',
    price: '₹3.32 Cr',
    status: 'Completed',
    units: '5 Units',
    landArea: '3,200 sq.ft',
    builtUpArea: '5,522 sq.ft',
    completion: '2008',
    description: 'Personal portfolio villas crafted with bespoke detailing and expansive living across prime Besant Nagar plots.',
    features: ['Bespoke Design', 'Private Terraces', 'Premium Finishes', 'Calm Neighborhood'],
    amenities: ['Private Parking', 'Garden Courts', 'Security Surveillance'],
    projectValue: '₹3.32 Cr'
  },
  {
    id: 2,
    type: 'Residential',
    city: 'Chennai',
    name: 'Vasuthalayam',
    address: 'West Mambalam',
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop',
    price: '₹1.75 Cr',
    status: 'Completed',
    units: '3 Units',
    landArea: '2,013 sq.ft',
    builtUpArea: '5,187 sq.ft',
    completion: '2021',
    description: 'Compact high-efficiency residences delivered under a contract model with meticulous execution and handover.',
    features: ['Efficient Floorplates', 'Smart Storage', 'Natural Ventilation', 'On-time Delivery'],
    amenities: ['Covered Parking', 'Power Backup', 'Security'],
    projectValue: '₹1.75 Cr'
  },
  {
    id: 3,
    type: 'Commercial',
    city: 'Chennai',
    name: 'Sriram Nivas',
    address: 'Guindy',
    image: '/images/sriramnivas.jpeg',
    price: '₹4.30 Cr',
    status: 'Completed',
    units: 'Commercial Space',
    landArea: '5,400 sq.ft',
    builtUpArea: '10,986 sq.ft',
    completion: '2021',
    description: 'Purpose-built commercial block housing office and retail footprints with efficient cores and services.',
    features: ['Mixed-Use Planning', 'Efficient Core', 'High Street Visibility', 'Grade-A Specs'],
    amenities: ['Retail Frontage', 'Office Floors', 'Visitor Parking', 'Cafeteria'],
    projectValue: '₹4.30 Cr'
  },
  {
    id: 4,
    type: 'Residential',
    city: 'Coimbatore',
    name: 'Guru Guha',
    address: 'Saravanampatti',
    image: '/images/guruguha.jpeg',
    price: '₹3.60 Cr',
    status: 'Completed',
    units: '2 Units',
    landArea: '2,400 sq.ft',
    builtUpArea: '5,663 sq.ft',
    completion: '2023',
    description: 'Twin villa development with landscaped courts, skylit interiors and efficient split-level planning.',
    features: ['Skylit Stairwell', 'Private Garden', 'Dual Living Zones', 'Premium Joinery'],
    amenities: ['Individual Car Bays', 'Security Systems', 'Water Features'],
    projectValue: '₹3.60 Cr'
  },
  {
    id: 5,
    type: 'Residential',
    city: 'Chennai',
    name: 'Bharadwaj Residence',
    address: 'Anna Nagar',
    image: '/images/bharadwaj.jpeg',
    price: '₹1.84 Cr',
    status: 'Completed',
    units: '3 Units',
    landArea: '2,695 sq.ft',
    builtUpArea: '5,580 sq.ft',
    completion: '2023',
    description: 'Three bespoke residences executed with contemporary façades, double-height living and premium finishes.',
    features: ['Double-height Living', 'Contemporary Facade', 'Smart Home Provision', 'Premium Finishes'],
    amenities: ['Lift Provision', 'Power Backup', 'Landscaped Portal'],
    projectValue: '₹1.84 Cr'
  },
  {
    id: 6,
    type: 'Residential',
    city: 'Chennai',
    name: 'Radha Residence',
    address: 'K.K. Nagar',
    image: '/images/Radha.jpeg',
    price: '₹1.37 Cr',
    status: 'Completed',
    units: '2 Units',
    landArea: '2,400 sq.ft',
    builtUpArea: '4,090 sq.ft',
    completion: '2023',
    description: 'Compact two-unit villa scheme optimized for corner daylight, private terraces and seamless circulation.',
    features: ['Corner Lighting', 'Terrace Garden', 'Custom Interiors', 'Efficient Circulation'],
    amenities: ['Covered Parking', 'Security', 'Rainwater Harvesting'],
    projectValue: '₹1.37 Cr'
  },
  {
    id: 7,
    type: 'Residential',
    city: 'Kodaikanal',
    name: 'Lalith Residence',
    address: 'Mountain View',
    image: '/images/lalith.jpeg',
    price: '₹3.01 Cr',
    status: 'Completed',
    units: 'Clinic cum Villa',
    landArea: '3,380 sq.ft',
    builtUpArea: '7,781 sq.ft',
    completion: '2024',
    description: 'Hybrid healthcare and residential program with dedicated clinic floors and private villa living above.',
    features: ['Dual-use Planning', 'Dedicated Clinic Floor', 'Private Villa Deck', 'Mountain Views'],
    amenities: ['Visitor Lobby', 'Private Residence Access', 'Parking', 'Security'],
    projectValue: '₹3.01 Cr'
  },
  {
    id: 8,
    type: 'Residential',
    city: 'Chennai',
    name: 'Aashritha Residence',
    address: 'Chennai South',
    image: ' /images/aashritha.jpeg ',
    price: '₹9.60 Cr (Est.)',
    status: 'Under Construction',
    units: '6 Units',
    landArea: '3,300 sq.ft',
    builtUpArea: '8,802 sq.ft',
    completion: '2026',
    description: 'Self-developed luxury row residences with expansive decks and wellness-focused amenities.',
    features: ['Self Development', 'Premium Wellness Deck', 'Smart Automation', 'EV Ready Garages'],
    amenities: ['Club Lounge', 'Fitness Studio', 'Dedicated Parking'],
    projectValue: '₹9.60 Cr'
  },
  {
    id: 9,
    type: 'Residential',
    city: 'Chennai',
    name: 'Niramaya Residence',
    address: 'Central Business District',
    image: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=800&h=600&fit=crop',
    price: '₹2.20 Cr (Est.)',
    status: 'Under Construction',
    units: '5 Units',
    landArea: '3,060 sq.ft',
    builtUpArea: '6,150 sq.ft',
    completion: '2025',
    description: 'Joint development boutique residences with shared amenities and efficient planning.',
    features: ['Joint Development', 'Shared Rooftop', 'Sustainable Materials', 'Efficient Core'],
    amenities: ['Rooftop Lounge', 'Solar Backup', 'Visitor Parking'],
    projectValue: '₹2.20 Cr'
  },
  {
    id: 10,
    type: 'Institutional',
    city: 'Chennai',
    name: 'Goshala',
    address: 'City Outskirts',
    image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&h=600&fit=crop',
    price: '₹1.32 Cr (Est.)',
    status: 'Under Construction',
    units: 'Community Facility',
    landArea: '43,560 sq.ft',
    builtUpArea: '22,100 sq.ft',
    completion: '2025',
    description: 'Dedicated animal care and shelter facility with administrative block and feeding zones.',
    features: ['Community Impact', 'Efficient Drainage', 'Admin Block', 'Feed Storage'],
    amenities: ['Shelter Bays', 'Admin Office', 'Security'],
    projectValue: '₹1.32 Cr'
  },
  {
    id: 11,
    type: 'Institutional',
    city: 'Adambakkam',
    name: 'Multipurpose Hall, Adambakkam',
    address: 'Adambakkam',
    image: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800&h=600&fit=crop',
    price: '₹2.50 Cr (Est.)',
    status: 'Under Construction',
    units: 'Event Facility',
    landArea: '3,000 sq.ft',
    builtUpArea: '7,000 sq.ft',
    completion: '2025',
    description: 'A multi-level community hall supporting conferences, social gatherings and cultural programs.',
    features: ['Large Span Halls', 'Acoustic Treatment', 'Service Core', 'Flexible Layout'],
    amenities: ['Banquet Space', 'Back-of-house', 'Parking'],
    projectValue: '₹2.50 Cr'
  },
  {
    id: 12,
    type: 'Residential',
    city: 'Adambakkam',
    name: 'Sri Nivasam, Adambakkam',
    address: 'Adambakkam',
    image: '/images/Srinivasam.jpeg',
    price: '₹1.75 Cr (Est.)',
    status: 'Under Construction',
    units: '4 Units',
    landArea: '3,040 sq.ft',
    builtUpArea: '5,411 sq.ft',
    completion: '2025',
    description: 'Four-unit premium apartment block optimized for compact urban plots.',
    features: ['4 Exclusive Units', 'Lift Access', 'High Ventilation', 'Vaastu Compliant'],
    amenities: ['Covered Parking', 'Power Backup', 'Video Door Phone'],
    projectValue: '₹1.75 Cr'
  },
  {
    id: 13,
    type: 'Residential',
    city: 'Chennai',
    name: 'Srimushnam, KK Nagar',
    address: 'KK Nagar',
    image: '/images/srimushnam.png',
    price: '₹1.75 Cr (Est.)',
    status: 'Proposed',
    units: 'Premium Residence',
    landArea: '3,520 sq.ft',
    builtUpArea: '3,116 sq.ft',
    completion: '2026',
    description: 'Upcoming bespoke residence blending traditional aesthetics with contemporary planning.',
    features: ['Traditional Facade', 'Courtyard Plan', 'Premium Interiors', 'Sustainable Systems'],
    amenities: ['Private Parking', 'Security', 'Landscaped Entry'],
    projectValue: '₹1.75 Cr'
  },
  {
    id: 14,
    type: 'Institutional',
    city: 'Kancheepuram',
    name: 'Kancheepuram SSAA Marriage Hall',
    address: 'Kancheepuram',
    image: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800&h=600&fit=crop',
    price: '₹7.50 Cr (Est.)',
    status: 'Proposed',
    units: 'Marriage Hall',
    landArea: '7,216 sq.ft',
    builtUpArea: '22,000 sq.ft',
    completion: '2027',
    description: 'Proposed large-format wedding and convention hall with guest amenities and back-of-house services.',
    features: ['Large Capacity', 'Guest Suites', 'Service Access', 'centralised Air Conditioning'],
    amenities: ['Banquet Hall', 'Guest Rooms', 'Kitchen Block', 'Parking'],
    projectValue: '₹7.50 Cr'
  }
];

export const ProjectsGridFiltered = ({ onProjectClick, selectedCityInit, selectedTypeInit }) => {
  const [selectedCity, setSelectedCity] = useState(selectedCityInit || '');
  const [selectedType, setSelectedType] = useState(selectedTypeInit || '');
  const filtered = allProjects.filter(p =>
    (!selectedCity || p.city === selectedCity) &&
    (!selectedType || p.type === selectedType)
  );
  return (
    <section className="projects-showcase-section">
      <div className="container">
        <motion.div className="section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }}>
          <h2 className="section-title">Find Your Project</h2>
        </motion.div>
        <div className="projects-filters">
          <div className="filter-group">
            <label className="filter-label">City</label>
            <div className="filter-buttons">
              {cities.map(city => (
                <button key={city} className={`filter-btn ${selectedCity === city ? 'active' : ''}`} onClick={() => setSelectedCity(city)}>{city}</button>
              ))}
            </div>
          </div>
          <div className="filter-group">
            <label className="filter-label">Property Type</label>
            <div className="filter-buttons">
              {projectTypes.map(type => (
                <button key={type} className={`filter-btn ${selectedType === type ? 'active' : ''}`} onClick={() => setSelectedType(type)}>{type}</button>
              ))}
            </div>
          </div>
        </div>
        <motion.div className="projects-showcase-grid" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.4 }} viewport={{ once: true }}>
          {filtered.length ? filtered.map((project, i) => (
            <motion.div key={project.id} className="project-showcase-card" onClick={() => onProjectClick(project)} whileHover={{ y: -8, boxShadow: 'var(--shadow-2xl)' }}>
              <div className="project-image-wrapper">
                <img src={project.image} alt={project.name} className="project-image" />
                <div className="project-status-badge">{project.status}</div>
              </div>
              <div className="project-card-content">
                <h3 className="project-name">{project.name}</h3>
                <p className="project-price">{project.price}</p>
                <div className="project-location">
                  <span>{project.address}, {project.city}</span>
                </div>
                <div className="project-details">
                  <span className="project-detail-item">{project.landArea} Land</span> <span className="project-detail-separator">•</span>
                  <span className="project-detail-item">{project.builtUpArea} Built-up</span> <span className="project-detail-separator">•</span>
                  <span className="project-detail-item">{project.units}</span>
                </div>
                <button
                  className="project-view-btn"
                  onClick={(event) => {
                    event.stopPropagation();
                    onProjectClick(project);
                  }}
                >
                  View Details
                </button>
              </div>
            </motion.div>
          )) : <div className="no-projects"><p>No projects found for the selected filters.</p></div>}
        </motion.div>
      </div>
    </section>
  );
};

export const ProjectDetails = ({ project }) => {
  if (!project) return null;
  return (
    <section className="project-details-section">
      <div className="container">
        <motion.div className="section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }}>
          <h2 className="section-title">Project Details</h2>
          <p className="section-subtitle">Detailed information about {project.name}</p>
        </motion.div>
        <motion.div className="project-details-container" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }}>
          <div className="project-details-grid">
            <div className="project-details-image">
              <img src={project.image} alt={project.name} />
            </div>
            <div className="project-details-content">
              <div className="project-details-header">
                <h3 className="project-details-title">{project.name}</h3>
                <p className="project-details-price">{project.price}</p>
                <div className="project-details-badge">{project.status}</div>
              </div>
              <p className="project-details-description">{project.details?.description || project.description}</p>
              <div className="project-details-info">
                <div className="details-info-row"><div className="details-info-item"><span className="details-label">📍 Location:</span><span className="details-value">{project.address}, {project.city}</span></div><div className="details-info-item"><span className="details-label">🏗️ Type:</span><span className="details-value">{project.type}</span></div></div>
                <div className="details-info-row"><div className="details-info-item"><span className="details-label">📐 Land Area:</span><span className="details-value">{project.landArea}</span></div><div className="details-info-item"><span className="details-label">🏗️ Built-up Area:</span><span className="details-value">{project.builtUpArea}</span></div></div>
                <div className="details-info-row"><div className="details-info-item"><span className="details-label">🏠 Units / Usage:</span><span className="details-value">{project.units}</span></div><div className="details-info-item"><span className="details-label">💰 Project Value:</span><span className="details-value">{project.projectValue || project.price}</span></div></div>
                <div className="details-info-row"><div className="details-info-item"><span className="details-label">📅 Completion Year:</span><span className="details-value">{project.details?.completion || project.completion}</span></div><div className="details-info-item"><span className="details-label">📊 Status:</span><span className="details-value">{project.status}</span></div></div>
              </div>
              <div className="project-details-features"><h4 className="features-title">Key Features</h4><div className="features-list">{(project.details?.features || project.features || []).map((feature, i) => <span key={i} className="feature-badge">{feature}</span>)}</div></div>
              <div className="project-details-amenities"><h4 className="amenities-title">Amenities</h4><ul className="amenities-list">{(project.details?.amenities || project.amenities || []).map((am, idx) => <li key={idx}>{am}</li>)}</ul></div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

